import React from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../../lib/contact";

const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.11 4.92A10 10 0 0 0 4.07 18.2L3 22l3.88-1.03A10 10 0 1 0 19.11 4.92Zm-7.1 15.34a8.27 8.27 0 0 1-4.21-1.15l-.3-.18-2.3.61.62-2.24-.2-.32a8.27 8.27 0 1 1 6.4 3.28Zm4.55-6.2c-.25-.12-1.47-.72-1.7-.8-.23-.09-.39-.13-.56.12-.16.24-.64.8-.78.96-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23a7.5 7.5 0 0 1-1.38-1.72c-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.14.17-.25.25-.41.08-.16.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.84-.2-.49-.41-.42-.56-.43h-.48a.92.92 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.02 2.6.13.17 1.76 2.69 4.27 3.77 1.49.64 2.07.7 2.81.59.45-.07 1.47-.6 1.68-1.19.21-.58.21-1.08.15-1.18-.07-.1-.23-.16-.49-.28Z" />
  </svg>
);

const Contact = () => {
  return (
    <section
      id="iletisim"
      data-testid="contact-section"
      className="py-20 lg:py-28 bg-[#0A192F] text-white relative overflow-hidden"
    >
      <div className="absolute -top-20 right-0 w-[420px] h-[420px] rounded-full bg-[#2563EB]/25 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[320px] h-[320px] rounded-full bg-emerald-500/15 blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 lg:px-8 max-w-7xl relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-xs font-bold tracking-[0.28em] uppercase text-[#60A5FA]">
            İletişim
          </div>
          <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Hemen ulaşın, <br />
            <span className="text-[#60A5FA]">teklifinizi alın.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/70 max-w-xl leading-relaxed">
            Halı yıkama işletmeniz için en uygun ürün ve fiyatları konuşalım. Tek bir
            tuşla iletişime geçebilirsiniz.
          </p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 max-w-3xl">
          {/* Phone card */}
          <motion.a
            href={`tel:${PHONE_TEL}`}
            data-testid="contact-phone-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="group rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-7 hover:bg-white/10 hover:border-[#60A5FA]/40 transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[#2563EB] grid place-items-center mb-5">
              <Phone className="w-5 h-5 text-white" />
            </div>
            <div className="text-xs font-bold uppercase tracking-widest text-white/60">
              Telefon
            </div>
            <div className="mt-2 font-heading font-extrabold text-2xl sm:text-3xl">
              {PHONE_DISPLAY}
            </div>
            <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#60A5FA] group-hover:gap-3 transition-all">
              Hemen Ara →
            </div>
          </motion.a>

          {/* WhatsApp card */}
          <motion.a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.12 }}
            className="group rounded-2xl bg-[#10B981]/10 border border-[#10B981]/30 backdrop-blur p-7 hover:bg-[#10B981]/15 transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[#10B981] grid place-items-center mb-5">
              <WhatsAppIcon className="w-5 h-5" />
            </div>
            <div className="text-xs font-bold uppercase tracking-widest text-white/60">
              WhatsApp
            </div>
            <div className="mt-2 font-heading font-extrabold text-2xl sm:text-3xl">
              {PHONE_DISPLAY}
            </div>
            <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#34D399] group-hover:gap-3 transition-all">
              Mesaj Gönder →
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
